import React from "react";
import styles from "./Modal.module.scss";
import classnames from "classnames";

interface ModalProps {
  isShowing: boolean;
  onClose?: () => void;
  header?: React.ReactNode;
  children: React.ReactNode;
  size?: string;
  className?: string;
  hideCloseButton?: boolean;
  noDefaultPadding?: boolean;
  closeOnBackdropClick?: boolean;
}

export default function Modal({
  isShowing,
  onClose,
  header,
  children,
  size = "medium",
  className,
  hideCloseButton = false,
  noDefaultPadding = false,
  closeOnBackdropClick = true,
}: ModalProps) {
  if (!isShowing) {
    return null;
  }

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (hideCloseButton || !onClose || !closeOnBackdropClick) {
      e.stopPropagation();
      return;
    }
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div
      className={classnames(styles.root, hideCloseButton && styles.blocking)}
      onClick={handleOverlayClick}
    >
      <div
        className={classnames(
          styles.contentContainer,
          size && styles[size],
          className,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={classnames(
            styles.header,
            hideCloseButton && styles.headerNoClose,
          )}
        >
          {header}
          {!hideCloseButton && (
            <div className={styles.closeButton}>
              <i className="fal fa-x" onClick={onClose} />
            </div>
          )}
        </div>

        <div
          className={classnames(
            styles.children,
            noDefaultPadding && styles.noPadding,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
